module.exports = __webpack_public_path__ + "img/banner.f3c589e4.png";